import { Box } from '@mui/material';
import { Fragment } from 'react';
import { highlightMatch } from '../lib/highlightMatch';

interface HighlightedTextProps {
  text: string;
  query: string;
}

function HighlightedText({ text, query }: HighlightedTextProps) {
  const segments = highlightMatch({ text, query });

  return (
    <>
      {segments.map((segment, index) =>
        segment.isMatch ? (
          <Box key={index} component="span" sx={{ fontWeight: 'bold' }}>
            {segment.text}
          </Box>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}

export default HighlightedText;
